import styled, { keyframes } from 'styled-components';

const fadeFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(50px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;
export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 30px 10%;
  background: #ddd;
  width: 100%;

  .dashboardButton{
    background: rgba(0,100,0) !important;
    color: #fff;
 
    padding: 10px;
   margin: 0px;
    border: 0px;

    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
    transition: 0.5s all;
 
    >svg{
      width: 30px;
      font-size: 30px;
      color: #fff;
    }

    &:hover{
      background: rgba(0,150,0) !important;
    }
  }

  .searchButton{
    background: rgba(0,100,0);
    color: #fff;
    width: 50px;
    height: 50px;
    padding: 10px;
    margin: 5px;
    border: 0px;

    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
    transition: 0.5s all;
    border-radius: 50%;

    >svg{
      width: 30px;
      font-size: 30px;
      color: #fff;
    }

    &:hover{
      background: rgba(0,150,0);
    }
  }
`;

export const Header = styled.div`
  width: 100%;
  background: none;
  color: #333;
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1200px) {
    flex-direction: column;
  }

  > div {
    display: flex;

    form {
      display: flex;

      > input {
        border: 0;
        padding: 20px;
        background: #eee;
        color: #333;
      }
      > button {
        border: 0;
        padding: 20px;
        background: rgb(0, 100, 150);
        color: #fff;
      }
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  min-height: auto;
  display: flex;
  overflow-x: auto;
  > table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ccc;
    table-layout: auto;
    background: white;
    margin-top: 10px;

    tr {

      transition: 0.4s all;
      &:hover{
        background: rgb(245,245,245);
      }
      td,
      th {
        border: 1px solid #ddd;
        text-align: left;
        color: #333;
        padding: 5px;
      }
    }

    tr + tr {
      border-top: 1px solid #999;
    }
  }
`;

export const Navigation = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: row;
  background: #ffffff;
  width: 100%;

  > button {
    width: 30px;
    min-width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: none;
    border: 1px solid #333;
    color: #333;
    font-size: 14px;
    margin: 3px;
  }

  > button.active {
    background: rgb(0, 100, 150);
    color: #ffffff;
    border-color: rgb(0, 100, 150);
  }

  > span {
    padding: 0px 10px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: 1px solid #333;
    color: #333;
    font-size: 14px;
    margin: 3px;
  }
`;

export const Field = styled.div`
  margin-top: 10px;
  > label {
    margin-bottom: 5px;
    display: flex;
  }
`;
